import {  UsePageTrackerProps } from './types'
import { useEffect, useRef } from 'react'
import { useTracker } from './contenxt'


// 集成调用默认触发page_jump page_out page_duration
const usePageTracker = (props: UsePageTrackerProps) => {
  const  tracker = useTracker()
  const propsRef = useRef(props)
  propsRef.current = props
  useEffect(() => {
    const { page_jump = true, page_out = true, data } = propsRef.current
    const startTime = new Date().getTime()
    page_jump &&
    tracker.onPageJump?.(data)
    const pageOutHandler = (isBeforeunload = true) => () => {
      const end = new Date().getTime()
      page_out &&
      tracker.onPageOut?.({
        duration: end - startTime,
        ...data
      }, isBeforeunload)
    }
    const beforeunloadHandler = pageOutHandler(true)
    window.addEventListener('beforeunload', beforeunloadHandler);
    return () => {
      window.removeEventListener('beforeunload', beforeunloadHandler)
      pageOutHandler(false)()
    }
  }, [tracker])
}

export default usePageTracker